module.exports = function() {
  return new Worker(__webpack_public_path__ + "9471b42cbf45b2221957.worker.js");
};